import React, { useEffect } from "react";

const TITHI_NAMES = [
  "અમાસ",
  "એકમ",
  "બીજ",
  "ત્રીજ",
  "ચોથ",
  "પાંચમ",
  "છઠ",
  "સાતમ",
  "આઠમ",
  "નવમ",
  "દશમ",
  "એકાદશી",
  "બારસ",
  "તેરસ",
  "ચૌદશ",
  "પૂનમ",
];

function AnimatedBackground() {
  useEffect(() => {
    const moon = document.querySelector(".moon");
    const bg = document.querySelector(".animated-bg");
    if (!moon || !bg) return;

    // Gujarati lunar day simulation (1–30)
    const today = new Date().getDate();
    const tithi = today % 30 || 30;

    // Determine phase progress
    let phaseProgress;
    if (tithi <= 15) {
      phaseProgress = tithi / 15; // Shukla Paksha
    } else {
      phaseProgress = (30 - tithi) / 15; // Krishna Paksha
    }

    // Moon size & brightness
    const size = 55 + phaseProgress * 40;
    moon.style.width = `${size}px`;
    moon.style.height = `${size}px`;
    moon.style.opacity = `${0.2 + phaseProgress * 0.8}`;

    // Tooltip (Gujarati tithi name)
    const tithiIndex = tithi <= 15 ? tithi : 30 - tithi;
    moon.setAttribute(
      "data-tithi",
      TITHI_NAMES[tithiIndex] || ""
    );

    // Krishna Paksha → more clouds
    if (tithi > 15) {
      bg.classList.add("krishna-paksha");
    } else {
      bg.classList.remove("krishna-paksha");
    }

    // Poonam glow pulse
    if (tithi === 15) {
      moon.classList.add("poonam");
    } else {
      moon.classList.remove("poonam");
    }

    // Amavasya almost invisible
    if (tithi === 30) {
      moon.classList.add("amavasya");
    } else {
      moon.classList.remove("amavasya");
    }
  }, []);

  return (
    <div className="animated-bg" aria-hidden="true">
      <div className="moon"></div>
    </div>
  );
}

export default AnimatedBackground;
